// Money Format

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

const subscription_boxes = document.querySelectorAll(".subscription-box");
subscription_boxes.forEach((subscription_box) => {
  const selected_option = subscription_box.querySelector(".selected-option");
  const comparePrice = subscription_box.querySelector(".selected-price");
  const radios = subscription_box.querySelectorAll('input[type="radio"]');

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selected_value = radio.nextSibling.innerHTML;
      const variantTitle = radio.dataset.variantTitle;
      const variantPrice =
        radio.nextElementSibling.querySelector(".__variant-price").innerHTML;

      if (variantTitle) {
        selected_option.innerHTML = variantTitle;
      } else {
        selected_option.innerHTML = selected_value;
      }

      if (comparePrice) {
        comparePrice.innerHTML = variantPrice;
      }

      subscription_box.removeAttribute("open");
    });
  });
});

function updateSubscriptionValues(variant) {
  const price = variant.price;
  const discountedPrice = price - (price * 30) / 100;

  document.querySelectorAll(
    ".bundleapp-plan-selector-group-pricing"
  )[0].textContent = Shopify.formatMoney(price);
  document.querySelectorAll(
    ".bundleapp-plan-selector-group-pricing"
  )[1].textContent = Shopify.formatMoney(discountedPrice);

  let numberOfBottles = parseInt(variant.option1.split(" ")[0], 10);

  document.querySelector("[data-one-time-option]").dataset.price = price;
  document.querySelector("[data-multiple-option]").dataset.price =
    discountedPrice;

  document.querySelector("[data-one-time-option]").dataset.bottleCount =
    numberOfBottles;
  document.querySelector("[data-multiple-option]").dataset.bottleCount =
    numberOfBottles;
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    updateSubscriptionValues(currentVariant);
  }, 300);
});

document.addEventListener("variant:change", function (event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant);
  updateSubscriptionValues(variant);

  document.querySelector(".js-sticky-product-atc").textContent = `${Shopify.formatMoney(price)} • 1 item • ADD TO CART`;
  
});

document.querySelectorAll(".bundleapp-wrapper input").forEach((item) => {
  item.addEventListener("change", () => {
    const price = item.dataset.price;
    const bottles = item.dataset.bottleCount;

    const itemPrice = price / bottles;
    console.log(Shopify.formatMoney(price));
    document.querySelector(".product-info sale-price").textContent =
      Shopify.formatMoney(price);
    document.querySelector(".item--price").textContent =
      Shopify.formatMoney(itemPrice);
  });
});

const scriptTag = document.querySelector("[data-product-json]");
if (scriptTag) {
 
const jsonData = JSON.parse(scriptTag.textContent);
const variants = jsonData.product.variants;
const selected_variant = jsonData.selected_variant_id; 
}

document
  .querySelectorAll('[name="bundleapp-plan-selector-group"]')
  .forEach((item) => {
    item.addEventListener("change", () => {
      let current_variant;

      // Get the current URL
      const url = new URL(window.location.href);

      // Use URLSearchParams to get the query parameters
      const params = new URLSearchParams(url.search);

      // Extract the variant value
      const variant = params.get("variant");

      if (variant) {
        current_variant = parseInt(variant); // Convert to integer for comparison
      } else {
        current_variant = parseInt(selected_variant); // Fallback to selected variant
      }

      console.log("Current Variant ID:", current_variant);
      console.log("Available Variants:", variants);

      // Find the matching variant
      const matchedVariant = variants.find(
        (variant) => variant.id === current_variant
      );

      if (item.value) {
        if (matchedVariant) {
          console.log("Matched Variant Title:", matchedVariant.title);
          const variant_option = matchedVariant.title.split("(");
          document.querySelector(".selected--variant").textContent =
            variant_option[0];
          const selling_plan_price =
            matchedVariant.selling_plan_allocations[0].price;
          document.querySelector(".atc-price").textContent =
            Shopify.formatMoney(selling_plan_price);
        }
      } else {
        document.querySelector(".atc-price").textContent = Shopify.formatMoney(
          matchedVariant["price"]
        );
      }
    });
  });
  
  
/// PDP Free Shipping Bar

document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail); 
  pdpFreeShipping(event.detail.cart.cart);
  document.querySelector('.pdp-free-shipping-bar')?.classList.remove('loader');
});

function pdpFreeShipping(cart) {
  const freeShippingThreshold = 15000; // in cents
  const totalCart = cart.total_price;

  // Convert to dollars
  const totalInDollars = totalCart / 100;
  const thresholdInDollars = freeShippingThreshold / 100;
  const percentage = Math.min((totalCart / freeShippingThreshold) * 100, 100);

  const pdpShippingMessage = document.querySelectorAll('.js-pdp-shipping-msg');
  const pdpPrgressBar = document.querySelectorAll('.js-pdp_progress');

  if (totalCart >= freeShippingThreshold) {
    pdpShippingMessage.forEach((element) => {
      element.textContent = "Congrats! You've unlocked FREE SHIPPING!";
    });
    pdpPrgressBar.forEach((element) => {
      element.style.width = "100%";
    });
    console.log("🎉 You qualify for FREE shipping!");
  } else {
    const remaining = (freeShippingThreshold - totalCart) / 100;
    console.log(remaining.toFixed(2));

    pdpShippingMessage.forEach((element) => {
      element.innerHTML = `You're <strong>$${remaining} away</strong> from free shipping!`;
    });
    
    pdpPrgressBar.forEach((element) => {
      element.style.width = `${percentage}%`;
    });

  }

  
}


// redesign-buy-button-subscription-form
class SubscriptionEvent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const mainForm = this.querySelector(".subscription-button_form");
    if (!mainForm) return;

    const atcWrapper = mainForm.querySelectorAll(".buy-featured-atc");
    const formInput = mainForm.querySelector("input[name='id']");

   
    const priceDiv = this.querySelector(".hover-price");
    if (!priceDiv) return;

    
    const defaultPriceHTML = priceDiv.innerHTML;

    atcWrapper.forEach((item) => {
      const btn = item.querySelector(".featured-atc-button");
      const VariantButtons = item.querySelectorAll(".variant--button");

      if (btn) {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          item.classList.toggle("active-button");
        });
      }

      VariantButtons.forEach((button) => {
       
        button.addEventListener("mouseover", () => {
          const variantPrice = button.getAttribute("data-variant-price");
          if (variantPrice) {
            priceDiv.textContent = `${variantPrice}`;
          }
        });

       
        button.addEventListener("mouseout", () => {
          priceDiv.innerHTML = defaultPriceHTML;
        });

        button.addEventListener("click", (event) => {
          event.preventDefault();

          const buttonValue = button.value;
          if (buttonValue) {
            formInput.value = buttonValue;
            mainForm.requestSubmit();

            document.addEventListener(
              "cart:change",
              () => {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
              },
              { once: true }
            );

            setTimeout(() => {
              item.classList.remove("active-button");
            }, 1500);
          }
        });
      });
    });
  }
}

customElements.define("subscription-event", SubscriptionEvent);


// redesign-buy-button-subscription-form


// redesign-buy-button-non-subscription-form
document.addEventListener("DOMContentLoaded", function () {
  const noSubForms = document.querySelectorAll(".non-subscription_form");
  noSubForms.forEach(form => {
    const details = form.querySelector(".buy-variant_selector");
    const summary = form.querySelector("summary");
    const summarySpan = summary.querySelector("span");
    const options = form.querySelectorAll(".option-value");
    const hiddenInput = form.querySelector("input[name='id']");
    const priceEl = form.querySelector(".buy__price");

    options.forEach(option => {
      option.addEventListener("click", function () {
        const variantId = this.dataset.variantId;
        const variantImage = this.dataset.variantImage;
        const variantPrice = this.dataset.variantPrice;
        const variantTitle = this.textContent.trim();
        summarySpan.textContent = variantTitle;
        hiddenInput.value = variantId;
        priceEl.textContent = variantPrice;
        details.removeAttribute("open");

        if (variantImage) {
          const productImage = form.closest(".product-card").querySelector(".product-card__media img");
          if (productImage) {
            productImage.src = variantImage;
            productImage.srcset = variantImage;
          }
        }

      });
    });

  });
});
// redesign-buy-button-non-subscription-form


